<template>
	<div class="main">
		<CribModel v-if="layerShow" :layerId="layerId" :pidRoute="pidRoute" @getSiteId="getSiteId"
			@getCribInfo="getCribInfo" />
			<div class="btn_contor" @click="changeReportShow">{{showReportTitle}}</div>
		<w2dDitu v-if="w2dshow" @getSiteId='getSiteId'>
		</w2dDitu>
		<w2dDuo v-else @back='back' @getduoiD15='getduoiD' @getduoiD13='getduoiD'>
		</w2dDuo>
		<div class="main-report animated fade-enter">
			<div class="main-left" v-show="showReport && !showInfo">
				<div class="main-left-list month-warn" style="padding: 1vw 1.1vw">
					<div class="list-title">月报警情况统计</div>
					<div class="month-warn-wrapper">
						<div class="warn-wrapper-list" v-for="(data, index) in warnList" :key="index">
							<div class="warn-wrapper-list-left">
								<a>{{ data.title }}</a>
								<span>
									8888
									<div class="warn-wrapper-num">{{ data.times }}</div>
								</span>
								<a class="times">次</a>
							</div>
							<div class="warn-wrapper-list-right">
								<a>已处理</a>
								<span>
									8888
									<div class="warn-wrapper-num">{{ data.afterTimes }}</div>
								</span>
								<a class="times">次</a>
							</div>
						</div>
					</div>
				</div>
				<div class="main-left-list" style="padding-left: 0.5vw">
					<div class="list-title">
						<a>养护阶段统计</a>
						<div class="list-title-unit">(单位:担)</div>
					</div>
					<div class="list-content">
						<div class="chart-wrapper" id="myChart1"></div>
					</div>
				</div>
				<div class="main-left-list">
					<div class="list-title">设备监控</div>
					<div class="list-facility-title">
						<div class="list-facility-item">类型</div>
						<div class="list-facility-item">正常</div>
						<div class="list-facility-item">异常</div>
					</div>
					<div class="list-facility-content">
						<div class="list-facility-content-item" v-for="(data, index) in facilityList" :key="index">
							<div class="item-list">{{ data.type }}</div>
							<div class="item-list">{{ data.normal }}</div>
							<div class="item-list">{{ data.abnormal }}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="main-left" v-show="showCrib && showInfo">
				<div class="main-left-list main-left-list-1">
					<div class="list-title">养护信息</div>
					<div class="maintenance-information">
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">垛位信息：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.siteName || "--" }}
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">烟叶代码：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.materialCode || "--" }}
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">养护阶段：</div>
							<div class="maintenance-information-value">
								{{
                  (cribInfo.maintainMessageVo.maintainStage &&
                    cribInfo.maintainMessageVo.maintainStage.displayName) ||
                  "--"
                }}
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">开始日期：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.aftercareDateStart || "--" }}
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">结束日期：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.aftercareDateEnd || "--" }}
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">已养护时间：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.curedTime || "--" }}天
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">养护数量：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.maintainCount || "--" }}件
							</div>
						</div>
						<div class="maintenance-information-list">
							<div class="maintenance-information-title">负责人：</div>
							<div class="maintenance-information-value">
								{{ cribInfo.maintainMessageVo.principalName || "--" }}
							</div>
						</div>
					</div>
				</div>
				<div class="main-left-list main-left-list-2">
					<div class="list-title">养护历史</div>
					<div class="maintenance-history">
						<div class="maintenance-history-list" v-for="(data, index) in cribInfo.maintainHistoryVoList"
							:key="index + 'maintainHistoryVoList'">
							<div class="maintenance-history-item">
								<div class="maintenance-history-name">养护阶段：</div>
								<div class="maintenance-history-value">
									{{ data.maintainStage.displayName }}
								</div>
							</div>
							<div class="maintenance-history-item">
								<div class="maintenance-history-name">开始时间：</div>
								<div class="maintenance-history-value">
									{{ data.aftercareDateStart }}
								</div>
							</div>
							<div class="maintenance-history-item">
								<div class="maintenance-history-name">养护天数：</div>
								<div class="maintenance-history-value">
									{{ data.maintainDays }}
								</div>
							</div>
						</div>
						<div class="none-data" v-if="cribInfo.maintainHistoryVoList.length < 1">
							暂无数据
						</div>
					</div>
				</div>
			</div>
			<div class="main-center" v-show="(showReport && !showInfo) || (showCrib && showInfo)">
				<div class="main-center-bottom">
					<div class="main-center-bottom-title">
						<div class="m-c-b-t-left">垛内日变化曲线</div>
						<div class="m-c-b-t-right">
							<div @click="changeBg(index)" class="m-c-b-t-right-item"
								:class="{ 'm-c-b-t-right-item-active': data.sign === '1' }"
								v-for="(data, index) in curveData" :key="index">
								{{ data.title }}
							</div>
						</div>
					</div>
					<div class="chart-wrapper" id="myChart3"></div>
				</div>
			</div>
			<div class="main-right" v-show="showReport && !showInfo">
				<div class="main-left-list month-warn">
					<div class="list-title">户外环境温湿度</div>
					<div class="month-warn-wrapper">
						<div class="warn-wrapper-list-">
							<div class="weather-box" v-for="item in outdoors" :key="item.index">
								<div class="weather-box-left weather-box-left-title">
									{{ item.stack }}
								</div>
								<div class="weather-box-right">
									<div>
										温度：<span style="color: #b58c00">{{ item.airTemp }}℃</span>
									</div>
									<div>
										湿度：<span style="color: #01c5f1">{{ item.airMoisture }}%</span>
									</div>
									<div>{{ getTime(item.createdTime) }}</div>
								</div>
							</div>
							<div class="weather-box">
								<div class="weather-box-left">
									<div class="weather-box-left-title">
										{{ nowWeather.cond_txt }}
									</div>
									<div class="weather-box-left-title">
										{{ nowWeather.wind_dir }}{{ nowWeather.wind_sc }}级
									</div>
								</div>
								<div class="weather-box-right">
									<div>
										温度：<span style="color: #b58c00">{{ nowWeather.tmp }}℃</span>
									</div>
									<div>
										湿度：<span style="color: #01c5f1">{{ nowWeather.hum }}%</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="main-left-list">
					<div class="list-title">仓库环境温湿度</div>
					<div class="select-title">
						<div class="title" :class="{ 'title-active': show }" @click="showTem">
							温度
						</div>
						<div class="title" :class="{ 'title-active': !show }" @click="showHum">
							湿度
						</div>
					</div>
					<div class="chart-wrapper" id="myChart2"></div>
				</div>
				<div class="main-left-list">
					<div class="list-title">
						<a>月虫情监控</a>
						<div class="list-title-unit">
							<div class="list-title-unit-logo"></div>
							<a>表示1%</a>
						</div>
					</div>
					<div class="plant-wrapper">
						<div class="plant-wrapper-left">
							<div class="plant-wrapper-msg">
								共计<a class="color-orange">0</a>垛
								<!-- 共计<a class="color-orange">{{ stackData.stackCount }}</a>垛 -->
							</div>
							<div class="plant-wrapper-msg">
								已处理<a class="color-orange">0</a>垛
								<!-- 已处理<a class="color-orange">{{ stackData.dealStackCount }}</a>垛 -->
							</div>
							<div class="plant-wrapper-num">
								虫数≥30：<a class="color-light">{{
                  stackData.stackPestCount30
                }}</a>垛
							</div>
							<div class="plant-wrapper-num">
								虫数≥10：<a class="color-light">{{
                  stackData.stackPestCount10
                }}</a>垛
							</div>
							<div class="plant-wrapper-num">
								虫数≥0：<a class="color-light">{{
                  stackData.stackPestCount0
                }}</a>垛
							</div>
						</div>
						<div class="boll">
							<div class="text">
								<div>虫屑率</div>
								<div class="num">0%</div>
								<!-- <div class="num">{{ stackData.percentage }}%</div> -->
							</div>
							<div class="water w1" ref="waterRef0"></div>
							<div class="water w2" ref="waterRef1"></div>
							<div class="water" ref="waterRef2"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="main-right" v-show="showCrib && showInfo">
				<div class="main-left-list main-left-list-3">
					<div class="list-title">设备列表</div>
					<div class="equipment-list">
						<div class="equipment-list-list" v-for="(data, index) in cribInfo.nodeListVoList"
							:key="index + 'nodeListVoList'">
							<div class="equipment-list-list-name">{{ data.nodeName }}</div>
							<div class="equipment-list-list-info">
								<div class="equipment-list-list-left">
									<div class="equipment-list-list-left-wrapper">
										<div class="equipment-list-list-left-name">ID：</div>
										<div class="equipment-list-list-left-value">
											{{ data.nodeId }}
										</div>
									</div>
									<div class="equipment-list-list-left-wrapper">
										<div class="equipment-list-list-left-name">位置：</div>
										<div class="equipment-list-list-left-value">
											X:{{ data.siteX }}&nbsp;&nbsp;Y:{{
                        data.siteY
                      }}&nbsp;&nbsp;Z:{{ data.siteZ }}
										</div>
									</div>
								</div>
								<div class="equipment-list-list-right" v-if="data.nodeType === '01'">
									<div class="equipment-list-list-right-number o-color">
										{{ data.transferData.oxygen }}%
									</div>
								</div>
								<div class="equipment-list-list-right" v-if="data.nodeType === '02'">
									<div class="equipment-list-list-right-number c-color">
										{{ data.transferData.concentrationCo2 }}PPM
									</div>
								</div>
								<div class="equipment-list-list-right" v-if="data.nodeType === '03'">
									<div class="equipment-list-list-right-number t-color">
										{{ data.transferData.airTemp }}℃
									</div>
									<div class="equipment-list-list-right-number h-color">
										{{ data.transferData.airMoisture }}%
									</div>
								</div>
								<div class="equipment-list-list-right" v-if="data.nodeType === '04'">
									<div class="equipment-list-list-right-number t-color">
										{{ data.transferData.temp }}℃
									</div>
								</div>
								<div class="equipment-list-list-right" v-if="data.nodeType === '05'">
									<div class="equipment-list-list-right-number h-color">
										{{ data.transferData.moist }}%
									</div>
								</div>
							</div>
							<div class="equipment-list-list-left-wrapper">
								<div class="equipment-list-list-left-name">采集时间：</div>
								<div class="equipment-list-list-left-value">
									{{ data.transferData.createdTime }}
								</div>
							</div>
						</div>
						<div class="none-data" v-if="cribInfo.nodeListVoList.length < 1">
							暂无数据
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		searchHomePageCount,
		searchStackCurveData,
		searchWarehouseTempMoist,
		warehouseNode,
		searchMaintainStage,
		searchMonthWarningCount,
	} from "../../../api/basic";
	import {
		searchStackInfo,
		searchAirMoirAndTemp
	} from "../../../api/maintain";
	import CribModel from "./CribModel";
	import w2dDitu from "./w2dDitu";
	import w2dDuo from "./w2dDuo.vue";
	import {
		renderTime
	} from "../../../tools/methods";
	import axios from "axios";
	let echarts = require("echarts");
	let myChart1;
	let myChart2;
	let myChart3;
	export default {
		name: "Main",
		components: {
			CribModel,
			w2dDitu,
			w2dDuo
		},
		data() {
			return {
				show: true,
				facilityList: [{
						type: "空调",
						normal: "0",
						abnormal: "0"
					},
					{
						type: "通风机",
						normal: "0",
						abnormal: "0"
					},
					{
						type: "抽湿机",
						normal: "0",
						abnormal: "0"
					},
					{
						type: "加湿机",
						normal: "0",
						abnormal: "0"
					},
				],
				warnList: [{
						title: "温湿预警",
						times: "0",
						afterTimes: "0"
					},
					{
						title: "湿度预警",
						times: "0",
						afterTimes: "0"
					},
					{
						title: "预警任务",
						times: "0",
						afterTimes: "0"
					},
					{
						title: "氧气预警",
						times: "0",
						afterTimes: "0"
					},
					{
						title: "水份预警",
						times: "0",
						afterTimes: "0"
					},
					{
						title: "二氧化碳",
						times: "0",
						afterTimes: "0"
					},
				],
				statisticalData: [{
						value: 0,
						name: "自然醇化",
						itemStyle: {
							color: "#facd89"
						}
					},
					{
						value: 0,
						name: "防霉杀虫",
						itemStyle: {
							color: "#8957a1"
						}
					},
					{
						value: 0,
						name: "气调醇化",
						itemStyle: {
							color: "#0085eb"
						}
					},
					{
						value: 0,
						name: "气调保质",
						itemStyle: {
							color: "#22ac38"
						}
					},
				],
				curveData: [{
						title: "包芯温度",
						sign: "1"
					},
					{
						title: "包芯水分",
						sign: "0"
					},
					{
						title: "二氧化碳",
						sign: "0"
					},
					{
						title: "氧气",
						sign: "0"
					},
					{
						title: "垛内温度",
						sign: "0"
					},
					{
						title: "垛内湿度",
						sign: "0"
					},
				],
				name_H: "温度/(℃)",
				type_H: 0,
				none_H: false,
				type_C: 0,
				none_C: false,
				stackData: {},
				siteId: "",
				siteType: "",
				warehouseNodeId: "",
				warehouseNodeType: "01",
				layerShow: false,
				// 平面地图
				w2dshow: true,
				layerList: [],
				layerId: "",
				pidRoute: "",
				showReport: true,
				showReportTitle: "隐藏",
				showInfo: false,
				showCrib: true,
				showCribTitle: "隐藏垛位信息",
				cribInfo: {
					maintainHistoryVoList: [],
					maintainMessageVo: {
						aftercareDateEnd: "",
						aftercareDateStart: "",
						curedTime: "",
						maintainCount: "",
						maintainStage: "",
						materialCode: "",
						principalName: "",
						siteName: "",
					},
					nodeListVoList: [],
				},
				outdoors: [],
				nowWeather: {},
			};
		},
		created() {
			this.StatisticsSearch();
			this.getOutdoors();
			this.getWeatherLivw();
			let _this = this;
			setTimeout(function() {
				_this.getCharts();
				myChart2 &&
					myChart2.on("legendselectchanged", function(obj) {
						if (
							obj.selected.最低 === false &&
							obj.selected.平均 === false &&
							obj.selected.最高 === false
						) {
							_this.name_H = "";
							_this.none_H = true;
							_this.getChart2();
						} else {
							_this.none_H = false;
							if (_this.type_H === 0) {
								_this.name_H = "温度/(℃)";
							} else {
								_this.name_H = "湿度/(%)";
							}
							_this.getChart2();
						}
					});
				myChart3 &&
					myChart3.on("legendselectchanged", function(obj) {
						if (
							obj.selected.最低 === false &&
							obj.selected.平均 === false &&
							obj.selected.最高 === false
						) {
							_this.none_C = true;
							_this.getChart3(-1);
						} else {
							_this.none_C = false;
							_this.getChart3(_this.type_C);
						}
					});
			}, 0);
		},
		methods: {
			// 首页养护阶段统计
			getChart1: function() {
				let body = {
					siteId: this.siteId,
					siteType: this.siteType,
				};
				searchMaintainStage(body)
					.then((res) => {
						console.log("首页养护阶段统计");
						console.log(res);
						//  养护阶段统计
						this.statisticalData[0].value = res.data.natureAging;
						this.statisticalData[1].value = res.data.ctlZymosisProofing;
						this.statisticalData[2].value = res.data.ctlAging;
						this.statisticalData[3].value = res.data.ctlJiq;

						myChart1 = echarts.init(document.getElementById("myChart1"));
						myChart1.setOption({
							legend: {
								orient: "vertical",
								right: 0,
								top: "center",
								data: this.statisticalData.name,
								textStyle: {
									color: "#ffffff",
								},
							},
							series: [{
								name: "访问来源",
								type: "pie",
								radius: "50%",
								center: ["35%", "50%"],
								// roseType: 'angle',
								itemStyle: {
									shadowBlur: 200,
									shadowColor: "rgba(0, 0, 0, 0.5)",
								},
								label: {
									textStyle: {
										color: "#ffffff",
									},
									normal: {
										show: true,
										formatter: "{c}",
									},
								},
								labelLine: {
									normal: {
										// lineStyle: {
										//   color: 'rgba(255, 255, 255, 0.3)'
										// },
										// smooth: 0.2,
										length: 5,
										length2: 20,
									},
								},
								data: this.statisticalData,
							}, ],
						});
						myChart1.on("click", function(params) {
							// 控制台打印数据的名称
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 首页仓库温湿度
			getChart2: function(type) {
				const that = this;
				let charData = {
					max: "",
					min: "",
					avg: "",
				};
				let body = {
					siteId: this.siteId,
					siteType: this.siteType,
				};
				searchWarehouseTempMoist(body)
					.then((res) => {
						console.log("首页仓库温湿度");
						console.log(res);
						let time = [];
						res.data.map((item) => {
							time.push(this.getTime(item.timeSlot));
						});
						if (type === 0) {
							charData.max = res.data.map((item) => {
								return item.maxVal1;
							});
							charData.min = res.data.map((item) => {
								return item.minVal1;
							});
							charData.avg = res.data.map((item) => {
								return item.avgVal1;
							});
						} else {
							charData.max = res.data.map((item) => {
								return item.maxVal2;
							});
							charData.min = res.data.map((item) => {
								return item.minVal2;
							});
							charData.avg = res.data.map((item) => {
								return item.avgVal2;
							});
						}
						myChart2 = echarts.init(document.getElementById("myChart2"));
						myChart2.setOption({
							tooltip: {
								trigger: "axis",
								axisPointer: {
									lineStyle: {
										type: "dashed"
									},
								},
							},
							textStyle: {
								color: "#ffffff"
							},
							legend: {
								bottom: "0",
								textStyle: {
									color: "#ffffff"
								},
								data: ["最低", "平均", "最高"],
							},
							grid: {
								top: "20%",
								right: "0",
								left: "5%",
								bottom: "15%",
								containLabel: true,
							},
							xAxis: {
								type: "category",
								splitLine: {
									show: false
								},
								axisTick: false,
								axisLine: {
									lineStyle: {
										color: "#32b16c"
									},
								},
								data: time,
							},
							yAxis: {
								type: "value",
								scale: "true",
								axisTick: false,
								splitLine: {
									lineStyle: {
										// 使用深浅的间隔色
										color: ["#2a2f57"],
									},
								},
								axisLine: {
									lineStyle: {
										color: "#32b16c"
									},
								},
								splitNumber: "5",
								name: this.name_H,
							},
							dataZoom: [{
								type: "inside",
								xAxisIndex: [0],
								startValue: 0,
								endValue: 2,
								minValueSpan: 3,
								maxValueSpan: 3,
								filterMode: "empty",
							}, ],
							axisLabel: {
								formatter: function(params) {
									return that.formatterLabel(params);
								},
								lineHeight: 15,
							},
							series: [{
									name: "最低",
									type: "line",
									itemStyle: {
										color: "#01c5f1"
									},
									data: charData.min,
								},
								{
									name: "平均",
									type: "line",
									itemStyle: {
										color: "#32b16c"
									},
									data: charData.avg,
								},
								{
									name: "最高",
									type: "line",
									itemStyle: {
										color: "#a84200"
									},
									data: charData.max,
								},
							],
						});
					})
					.catch((err) => {
						console.log(err);
					});
			},
			// 首页垛位曲线数据
			getChart3: function(type) {
				const that = this;
				let myChart3Data = {};
				let mark = "";
				let body = {
					siteId: this.siteId,
					siteType: this.siteType,
				};
				searchStackCurveData(body)
					.then((res) => {
						console.log("首页垛位曲线数据");
						console.log(res);
						let time = [];
						res.data.map((item) => {
							time.push(this.getTime(item.timeSlot));
						});
						if (type === -1) {
							mark = "";
						} else if (type === 0) {
							mark = "温度（℃）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxTemp ? item.maxTemp : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minTemp ? item.minTemp : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgTemp ? item.avgTemp : 0;
							});
						} else if (type === 1) {
							mark = "水分（%）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxMoist ? item.maxMoist : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minMoist ? item.minMoist : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgMoist ? item.avgMoist : 0;
							});
						} else if (type === 2) {
							mark = "含量（%）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxCO2 ? item.maxCO2 : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minCO2 ? item.minCO2 : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgCO2 ? item.avgCO2 : 0;
							});
						} else if (type === 3) {
							mark = "含量（%）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxO2 ? item.maxO2 : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minO2 ? item.minO2 : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgO2 ? item.avgO2 : 0;
							});
						} else if (type === 4) {
							mark = "温度（℃）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxAirTemp ? item.maxAirTemp : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minAirTemp ? item.minAirTemp : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgAirTemp ? item.avgAirTemp : 0;
							});
						} else if (type === 5) {
							mark = "湿度（%）";
							myChart3Data.max = res.data.map((item) => {
								return item.maxAirMoisture ? item.maxAirMoisture : 0;
							});
							myChart3Data.min = res.data.map((item) => {
								return item.minAirMoisture ? item.minAirMoisture : 0;
							});
							myChart3Data.avg = res.data.map((item) => {
								return item.avgAirMoisture ? item.avgAirMoisture : 0;
							});
						}
						myChart3 = echarts.init(document.getElementById("myChart3"));
						myChart3.setOption({
							tooltip: {
								trigger: "axis",
								axisPointer: {
									lineStyle: {
										type: "dashed"
									},
								},
							},
							textStyle: {
								color: "#ffffff"
							},
							legend: {
								right: "0",
								top: "5%",
								textStyle: {
									color: "#ffffff"
								},
								data: ["最低", "平均", "最高"],
							},
							grid: {
								top: "20%",
								right: "3%",
								left: "3%",
								bottom: "5%",
								containLabel: true,
							},
							xAxis: {
								type: "category",
								splitLine: {
									show: false
								},
								axisTick: false,
								axisLine: {
									lineStyle: {
										color: "#32b16c"
									},
								},
								axisLabel: {
									interval: 11,
									rotate: 0,
								},
								inverse:true,
								data: time,
							},
							yAxis: {
								type: "value",
								scale: "true",
								axisTick: false,
								splitLine: {
									lineStyle: {
										// 使用深浅的间隔色
										color: ["#2a2f57"],
									},
								},
								axisLine: {
									lineStyle: {
										color: "#32b16c"
									},
								},
								splitNumber: "5",
								name: mark,
							},
							dataZoom: [{
								type: "inside",
								xAxisIndex: [0],
								startValue: 0,
								endValue: 12,
								minValueSpan: 12,
								maxValueSpan: 12,
								filterMode: "empty",
							}, ],
							axisLabel: {
								formatter: function(params) {
									return that.formatterLabel(params);
								},
								lineHeight: 15,
							},
							series: [{
									name: "最低",
									type: "line",
									symbol: "circle",
									itemStyle: {
										normal: {
								
											lineStyle: {
												color: "#01c5f1",
											},
											color: "#01c5f1",
										},
									},
									data: myChart3Data.min,
								},
								{
									name: "平均",
									type: "line",
									symbol: "circle",
									itemStyle: {
										color: "#32b16c"
									},
									data: myChart3Data.avg,
								},
								{
									name: "最高",
									type: "line",
									symbol: "circle",
									itemStyle: {
										color: "#a84200"
									},
									data: myChart3Data.max,
								},
							],
						});
						window.onresize = function() {
							myChart1.resize();
							myChart2.resize();
							myChart3.resize();
						};
					})
					.catch((err) => {
						console.log(err);
					});
			},
			formatterLabel: function(params) {
				let value = params.toString().split(" ");
				if (value[1]) {
					return value[0] + "\n" + value[1];
				} else {
					return value[0];
				}
			},
			getCharts: function() {
				this.getChart1();
				this.getChart2(this.type_H);
				this.getChart3(this.type_C);
			},
			showTem: function() {
				this.type_H = 0;
				if (this.none_H) {
					this.name_H = "";
				} else {
					this.name_H = "温度/(℃)";
				}
				this.getChart2(this.type_H);
				this.show = true;
			},
			showHum: function() {
				this.type_H = 1;
				if (this.none_H) {
					this.name_H = "";
				} else {
					this.name_H = "湿度/(%)";
				}
				this.getChart2(this.type_H);
				this.show = false;
			},
			changeBg: function(type) {
				if (this.none_C) {
					this.getChart3(-1);
				} else {
					this.getChart3(type);
				}
				this.type_C = type;
				this.curveData.map((data, index) => {
					data.sign = "0";
					if (type === index) {
						data.sign = "1";
					}
				});
			},
			StatisticsSearch: function() {
				let body = {
					siteId: this.siteId,
					siteType: this.siteType,
				};
				searchMonthWarningCount(body)
					.then((res) => {
						console.log("首页月预警数量统计");
						console.log(res);
						// 月报警情况统计
						this.warnList[0].times = res.data.tempWarning;
						this.warnList[1].times = res.data.moistureWarning;
						this.warnList[2].times = res.data.taskWarning;
						this.warnList[3].times = res.data.o2Warning;
						this.warnList[4].times = res.data.wetWarning;
						this.warnList[5].times = res.data.co2Warning;
						this.warnList[0].afterTimes = res.data.tempWarningFlag;
						this.warnList[1].afterTimes = res.data.moistureWarningFlag;
						this.warnList[2].afterTimes = res.data.taskWarningFlag;
						this.warnList[3].afterTimes = res.data.o2WarningFlag;
						this.warnList[4].afterTimes = res.data.wetWarningFlag;
						this.warnList[5].afterTimes = res.data.co2WarningFlag;
					})
					.catch((err) => {
						console.log(err);
					});
				searchHomePageCount()
					.then((res) => {
						console.log("首页不传参当月各类统计");
						console.log(res);
						// 设备监控
						this.facilityList[0].normal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.airConditionerNormal :
							0;
						this.facilityList[1].normal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.ventilatorNormal :
							0;
						this.facilityList[2].normal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.dehumidifiersNormal :
							0;
						this.facilityList[3].normal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.humidifierNormal :
							0;
						this.facilityList[0].abnormal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.airConditionerAbnormal :
							0;
						this.facilityList[1].abnormal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.ventilatorAbnormal :
							0;
						this.facilityList[2].abnormal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.dehumidifiersAbnormal :
							0;
						this.facilityList[3].abnormal = res.data.equipmentMonitorVo ?
							res.data.equipmentMonitorVo.humidifierAbnormal :
							0;
						// 虫情监控
						this.stackData = res.data.pestCountBodyVo;
						this.stackData.percentage = (
							res.data.pestCountBodyVo.dealStackCount /
							res.data.pestCountBodyVo.stackCount
						).toFixed(2);
						this.$refs.waterRef0.style.top = this.$refs.waterRef1.style.top = this.$refs.waterRef2
							.style.top =
							100 - this.stackData.percentage * 100 + "%";
					})
					.catch((err) => {
						console.log(err);
					});
				this.getCharts();
			},
			// 获取户外环境温湿度
			getOutdoors: function() {
				searchAirMoirAndTemp()
					.then((res) => {
						console.log(res);
						this.outdoors = res.data;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			getTime: function(time) {
				return renderTime(time);
			},
			changeLayer: function(ind) {
				this.layerList.map((data, index) => {
					data.sign = 0;
					if (ind === index) {
						data.sign = 1;
						this.layerId = data.id;
						this.pidRoute =
							data.pidRoute + "," + "[" + data.siteType + ":" + data.id + "]";
					}
				});
			},

			// 测试使用
			getLayer: function(data) {
				let body = {
					warehouseNodeId: data,
					warehouseNodeType: "03",
				};
				warehouseNode(body)
					.then((res) => {
						// console.log('获取位置信息')
						// console.log(res)
						res.data.map((data, index) => {
							data.sign = 0;
							if (index === 0) {
								data.sign = 1;
								this.layerId = data.id;
								this.pidRoute =
									data.pidRoute + "," + "[" + data.siteType + ":" + data.id + "]";
							}
						});
						this.layerList = res.data;
						this.layerShow = true;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			back: function() {
				let body = {
					siteId: "",
					siteType: "",
					// 测试使用
					nameflase: true,
				};
				this.layerShow = false;
				this.getSiteId(body);
			},
			getSiteId: function(data) {
				console.log(data);
				// 测试使用
				this.w2dshow = data.nameflase;

				if (data.siteType !== "05") {
					this.showInfo = false;
				}
				this.siteId = data.siteId;
				this.siteType = data.siteType;
				this.StatisticsSearch();
			},
			// 测试使用
			getduoiD: function(data) {
				console.log(data);
				// 测试使用
				this.siteId = data.siteId;
				this.siteType = data.siteType;
				this.StatisticsSearch();
				this.getCribInfo(data.siteId, data.siteName)
			},
			changeReportShow: function() {
				if (this.showReport) {
					this.showReport = false;
						this.showCrib = false;
					this.showReportTitle = "显示";
				} else {
					this.showReport = true;
					this.showCrib = true;
					this.showReportTitle = "隐藏";
				}
			},
			changeCribShow: function() {
				if (this.showCrib) {
					this.showCrib = false;
					this.showCribTitle = "显示垛位信息";
				} else {
					this.showCrib = true;
					this.showCribTitle = "隐藏垛位信息";
				}
			},
			// 测试使用
			// siteid  13 271 15 272
			getCribInfo: function(siteId, siteName) {
				this.showInfo = true;
				console.log(siteId);
				let body = {
					siteId: siteId,
				};
				searchStackInfo(body)
					.then((res) => {
						console.log(res);
						this.cribInfo.maintainMessageVo = res.data.maintainMessageVo;
						this.cribInfo.maintainMessageVo.siteName = siteName;
						this.cribInfo.maintainMessageVo.aftercareDateStart =
							res.data.maintainMessageVo.aftercareDateStart &&
							renderTime(res.data.maintainMessageVo.aftercareDateStart);
						this.cribInfo.maintainMessageVo.aftercareDateEnd =
							res.data.maintainMessageVo.aftercareDateEnd &&
							renderTime(res.data.maintainMessageVo.aftercareDateEnd);
						res.data.maintainHistoryVoList.map((data) => {
							data.aftercareDateStart = renderTime(data.aftercareDateStart);
						});
						this.cribInfo.maintainHistoryVoList = res.data.maintainHistoryVoList;
						res.data.nodeListVoList.map((data) => {
							data.nodeName = this.getNodeName(data.nodeType);
						});
						this.cribInfo.nodeListVoList = res.data.nodeListVoList;
					})
					.catch((err) => {
						console.log(err);
					});
			},
			getNodeName: function(nodeType) {
				if (nodeType === "01") {
					return "无线氧气传感器";
				} else if (nodeType === "02") {
					return "无线二氧化碳传感器";
				} else if (nodeType === "03") {
					return "无线温湿度传感器";
				} else if (nodeType === "04") {
					return "无线包芯温度传感器";
				} else if (nodeType === "05") {
					return "无线包芯水分传感器";
				}
			},
			getWeatherLivw: function() {
				axios
					.get(
						"https://free-api.heweather.net/s6/weather/now?location=CN101230201&key=2bb68eb49add4f8c9d9b66a36d799b1d"
					)
					.then((res) => {
						console.log(res);
						this.nowWeather = res.data.HeWeather6[0].now;
						console.log(this.nowWeather);
					})
					.catch((err) => {
						console.log(err);
					});
			},
			showname: function(name) {
				this.w2dshow = name.nameflase;
			},
			hidename: function(name) {
				this.w2dshow = name;
				let body = {
					siteId: "",
					siteType: "",
				};
				this.layerShow = false;
				this.getSiteId(body);
			}
		},
	};
</script>

<style scoped>
	@import "Main.css";
	.btn_contor{
		position: absolute;
		left: 70.5rem;
		top: 0;
		z-index: 99999;
		width: 3.75rem;
		height: 1.875rem;
		line-height: 1.875rem;
		background-color: #00D2FF;
	}
</style>



// WEBPACK FOOTER //
// src/page/maintain/main/Main.vue